<template>
  <BaseCardPostSchedule
    :post="post"
    :learning-unit="learningUnit"
    :learning-outcome="learningOutcome"
    :date="date"
    :post-schedule="postSchedule"
    :is-show-full-content="isShowFullContent"
    :is-private="isPrivate"
    :active-hide-content-wrapper="activeHideContentWrapper"
    :can-edit-or-delete="false"
    class="mb-5"
  >
    <template v-slot:footer="{}">
      <div class="container__submission">
        <div class="card-body py-0">
          <div class="header__title">Submission/Feedback</div>
        </div>
        <!-- Profile -->
        <div
          class="d-flex bg-light justify-content-between align-items-center mt-3 p-3 border-top border-bottom border-medium"
        >
          <BaseUserProfile
            v-if="user"
            :user-name="user.name"
            class="container__submission-user-profile"
          >
            <template slot="name">
              <div class="ml-2">
                <div class="text-dark">
                  {{ user.name }}
                </div>

                <BaseTagSubmissionStatus :status="userStatus" />
              </div>
            </template>
          </BaseUserProfile>
        </div>

        <list-response
          ref="listResponse"
          :post="post"
          :post-schedule="postSchedule"
          :learner="learner"
          :learning-outcome="learningOutcome"
          :assessment-status="assessmentStatus"
          active
        />

        <!-- <response-submission v-if="latestSubmission" :post-response="latestSubmission" />

        <div v-if="
          latestSubmission &&
          postResponsesAfterLatestSubmission &&
          postResponsesAfterLatestSubmission.length
        ">
          <response-feedback v-for="evaluation in postResponsesAfterLatestSubmission" :key="`feedback-${evaluation.id}`"
            :post-response="evaluation" :learning-outcome="learningOutcome" :additional-criterions="additionalCriteria"
            :is-evaluated-by-learning-outcome="post.evaluate_learning_outcome" />
        </div> -->

        <div v-if="!isAllPassed" class="card-body py-0">
          <VueElementLoading :active="isSaving" />

          <BaseInput
            id="response-description"
            v-model="description"
            input-type="textarea"
            label="Your Response"
            placeholder="Enter your response"
            :is-invalid="submitFail"
            invalid-warning-text="Response must be at least 1 character or at least 1 attachment"
            class="mt-4 container__submission-response"
          />

          <div class="d-flex align-items-center justify-content-between">
            <BaseFilesUploadButton
              class="pl-2 py-2 mr-auto btn__attach-file"
              @add-files="addFiles"
            />

            <b-button variant="primary" class="btn__submit-response" @click="submit">
              Send
            </b-button>
          </div>

          <BaseFilesList
            :attachments="attachments"
            enable-delete
            class="pt-2 pb-4"
            @delete-file="deleteFile"
          />

          <base-s3-uploader
            v-show="false"
            id="input-attachments"
            ref="attachmentUploader"
            :reference-meta="{ ...referenceMeta, field: 'attachments' }"
            :disabled="isSaving"
            :is-public="false"
          >
          </base-s3-uploader>
        </div>
      </div>
    </template>
  </BaseCardPostSchedule>
</template>

<script>
// import { map, orderBy } from "lodash";
import BaseCardPostSchedule from '@/components/base-components/BaseCardPostSchedule';
import BaseFilesUploadButton from '@/components/base-components/BaseFilesUploadButton';
import BaseFilesList from '@/components/base-components/BaseFilesList';
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import BaseInput from '@/components/base-components/BaseInput';
import BaseTagSubmissionStatus from '@/components/base-components/BaseTagSubmissionStatus';
import BaseS3Uploader from '@/components/base-components/BaseS3Uploader';
import LearningUnit from '@/models/LearningUnit';
import LearningOutcome from '@/models/LearningOutcome';
import User from '@/models/User';
import PostResponse from '@/models/PostResponse';
import AdditionalCriterion from '@/models/AdditionalCriterion';
import AssessmentStatus from '@/models/AssessmentStatus';
import Status from '@/models/Status';
import { notificationMixin } from '@/mixins';
import ListResponse from './ListResponse';
import VueElementLoading from 'vue-element-loading';
// import ResponseSubmission from "./ResponseSubmission";
// import ResponseFeedback from "./ResponseFeedback";
// import User from "@/models/User";

export default {
  name: 'CardResponse',

  components: {
    VueElementLoading,
    BaseCardPostSchedule,
    BaseFilesUploadButton,
    BaseFilesList,
    BaseUserProfile,
    BaseInput,
    ListResponse,
    BaseTagSubmissionStatus,
    // ResponseSubmission,
    // ResponseFeedback,
    BaseS3Uploader
  },

  mixins: [notificationMixin],

  props: {
    post: {
      type: Object,
      default: () => {}
    },

    learner: {
      type: Object,
      required: true
    },

    date: {
      type: Date,
      default: () => new Date()
    },

    isPrivate: {
      type: Boolean,
      default: false
    },

    isShowFullContent: {
      type: Boolean,
      default: true
    },

    // postResponses: {
    //   type: Array,
    //   default: () => [],
    // },

    postSchedule: {
      type: Object,
      default: () => {}
    },

    activeHideContentWrapper: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      description: '',
      attachments: [],
      submitFail: false,
      isSaving: false,
      referenceMeta: {
        ref: 'post-response',
        refId: null
      }
    };
  },

  computed: {
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query().where('id', this.learningUnitId).first();
    },

    postId() {
      return Number.parseInt(this.$route.params.postId);
    },

    learningOutcome() {
      return LearningOutcome.query().where('learning_unit_id', this.learningUnitId).first();
    },

    assessmentStatus() {
      return AssessmentStatus.query()
        .with('status')
        .where('post_id', this.postId)
        .where('user_id', this.user.id)
        .first();
    },

    userStatus() {
      return this.assessmentStatus ? this.assessmentStatus.status : Status.notSubmitted;
    },

    user() {
      return User.query().first();
    },

    additionalCriteria() {
      return AdditionalCriterion.query().where('post_id', this.postId).get();
    },

    isAllPassed() {
      return this.userAssessmentStatus?.status_id === Status.PASSED;
    }

    // latestSubmission() {
    //   let latestSubmission = null;

    //   const sortedSubmissions = orderBy(
    //     this.postResponses.filter(
    //       (postResponse) => postResponse.assessment_submission !== null
    //     ),
    //     ["created_at"],
    //     ["desc"]
    //   );

    //   if (sortedSubmissions && sortedSubmissions.length) {
    //     latestSubmission = sortedSubmissions[0];
    //   }

    //   return latestSubmission;
    // },

    // otherPostResponses() {
    //   return this.postResponses.filter(({ id, created_at }) => {
    //     let filter =
    //       id !== this.latestSubmission.id &&
    //       created_at <= this.latestSubmission.created_at;

    //     return filter;
    //   });
    // },

    // postResponsesAfterLatestSubmission() {
    //   const { otherPostResponses = [] } = this;

    //   const postResponseIds = map(otherPostResponses, "id");

    //   return this.postResponses.filter(({ id, created_at }) => {
    //     let filter =
    //       id !== this.latestSubmissionId &&
    //       postResponseIds.indexOf(id) === -1 &&
    //       created_at > this.latestSubmission.created_at;

    //     return filter;
    //   });
    // },
  },

  watch: {
    description(newDesc) {
      if (newDesc) {
        newDesc = newDesc.trim();

        if (newDesc.length) {
          this.submitFail = false;
        }
      }
    },

    attachments(newAtt) {
      if (newAtt.length > 0) this.submitFail = false;
    }
  },

  methods: {
    addFiles(files) {
      this.attachments = this.attachments.concat(files);
    },

    deleteFile(index) {
      this.attachments.splice(index, 1);
    },

    async submit() {
      let { description = '' } = this;

      description = description.trim();

      if (!description.length && !this.attachments.length) {
        this.submitFail = true;
        return;
      }

      console.log('description :', this.description);
      console.log('attachments :', this.attachments);
      try {
        this.isSaving = true;
        // create post-response
        const body = {
          user: this.user.id,
          post: this.postId,
          learning_unit: this.$route.params.learningUnitId,
          section: this.$route.params.sectionId,
          description
        };

        const resultPostResponse = await PostResponse.api().responseByLearner(body);

        const postResponseId = resultPostResponse.response.data.id;

        // upload file
        let uploadedAttachments = [];

        if (this.attachments.length > 0) {
          this.$set(this.referenceMeta, 'refId', postResponseId);

          this.$refs.attachmentUploader.addFiles(this.attachments);

          uploadedAttachments = await this.$refs.attachmentUploader.upload();
        }

        // update assessment status
        AssessmentStatus.deleteAll();

        await AssessmentStatus.api().fetchPostStatus(this.user.id, this.postId);

        // update data in vuex orm
        await resultPostResponse.save();

        if (uploadedAttachments.length) {
          PostResponse.update({
            where: postResponseId,
            data: { attachments: uploadedAttachments }
          });
        }

        // this.$emit("submitSuccess", postResponseId);

        this.notiSuccess('response', 'sent');

        this.clear();

        this.isSaving = false;

        this.$refs.listResponse.refresh();
      } catch (error) {
        console.log('send response fail bruhhhh: ', error);
        this.notiError();
        throw new Error(error);
      }
    },

    clear() {
      this.description = '';
      this.attachments = [];
    }
  }
};
</script>
